import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AccountOption } from 'src/app/pages/account-register/models/account-option.interface';

@Injectable({ providedIn: 'root' })
export class SelectedAccountService {
   private selectedAccount$ = new BehaviorSubject<AccountOption | null>(null);

   setSelectedAccount(account: AccountOption | null) {
      this.selectedAccount$.next(account);
   }

   getSelectedAccount() {
      return this.selectedAccount$.asObservable();
   }
}
